import {lazy} from "react";

const SearchOrganization = lazy(() => import("./SearchOrganization"));

const organizationRoutes = [
    {
        path: "/organization",
        element: <SearchOrganization/>,
    },
];

export default organizationRoutes;